import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material"; 
import NoData from "../../components/NoData/NoData";
import CustomCheckbox from "../../components/CustomCheckbox";
import ManualSkeleton from "./ManualSkeleton";
import ManualRow from "./ManualRow";

const cellStyle = {
  padding: "10px 16px",
};

const ManualTable = ({ data = [], isActiveCell, isArchivedCell, isArchivedSkeleton = false }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const handleSelectAll = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((row) => row.id));
    }
  };

  const handleRowToggle = (id) => () => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const allSelected = selectedRows.length === data.length && data.length > 0;
  const someSelected = selectedRows.length > 0 && !allSelected;

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ boxShadow: "none", background: "transparent", marginBottom: "24px" }}
      >
        <Table size="small" sx={{ borderCollapse: "separate", borderSpacing: "0 5px" }}>
          <TableHead sx={{ backgroundColor: "#DFDFDF" }}>
            <TableRow>
              <TableCell
                sx={{
                  ...cellStyle,
                  border: "none",
                  minWidth: "50px",
                  maxWidth: "32px",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                }}
              >
                <CustomCheckbox
                  checked={allSelected}
                  indeterminate={someSelected}
                  onChange={handleSelectAll}
                />
              </TableCell>
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "start" }}>
                #
              </TableCell>
               
             {isActiveCell && ( <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center" }}>
                Add On 
              </TableCell>)}
              
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "left" }}>
                Organizations Name
              </TableCell>
              {isActiveCell && (<TableCell></TableCell> )}
              {isActiveCell && (<TableCell></TableCell> )}
              {isArchivedSkeleton && (<TableCell></TableCell> )}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              [...Array(3)].map((_, i) => <ManualSkeleton key={i} isActiveCell={isActiveCell} isArchivedSkeleton={isArchivedSkeleton} />)
            ) : data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ padding: "40px 16px" }}>
                  <NoData titleNoData="No Organizations Archived"  bodyNoData="You haven't archived any organizations yet. Once you do, they’ll appear here for easy reference and management."  />
                </TableCell>
              </TableRow>
            ) : (
              data.map((row) => (
                <ManualRow
                  key={row.id}
                  row={row}
                  isSelected={selectedRows.includes(row.id)}
                  onSelectToggle={handleRowToggle(row.id)}
				  isActiveCell={isActiveCell}
				  isArchivedCell={isArchivedCell}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ManualTable;